<course-modal
    [modalWidth]="600"
>
    <ng-container slot="modal">
        <h1 i18n="@@support.pinCode">Your support PIN-code</h1>
        <ng-container i18n="@@support.pinCodeLongInfo">
            <p>Our support staff may request this PIN-code for security purposes.</p>
            <p>Please copy and paste this PIN in your support request.</p>
            <p>Please keep this code secure. Note that your code is only valid for 48 hours.</p>
        </ng-container>
        <p>
            <mat-form-field appearance="outline">
                <mat-label i18n="@@support.pinCode">Your support PIN-code</mat-label>
                <input matInput readonly [value]="pinCode">
                <button mat-icon-button matSuffix (click)="copy()">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </mat-form-field>
        </p>
    </ng-container>

    <ng-container slot="controls">
        <button mat-flat-button color="primary" (click)="copy()">
            <mat-icon>content_copy</mat-icon>
            <ng-container i18n="@@support.copyToClipboard">Copy to clipboard</ng-container>
        </button>
    </ng-container>
</course-modal>
